import React from "react"
import "the-new-css-reset/css/reset.css";
import { StaticImage } from "gatsby-plugin-image";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFingerprint, faGift, faScissors, faStar, faHammer } from '@fortawesome/free-solid-svg-icons'

import Layout from "../components/layout"
import Seo from "../components/seo"
import Logo from "../components/logo";

import "./index.scss"
import NftCardBig from "../components/nftCardBig";
import NftCard from "../components/nftCard";

const IndexPage = () => (
  <Layout className="index">
    <section className="title">
      <Logo title />
      <div className="title-text">
        <h1>Collect, Craft, Swap, Earn!</h1>
        <span className="subtitle">Embark on a Voyage Through the Depths of Financial Wonderland with Marine Moguls, 
          where every token is a treasure map to untold riches and thrilling market adventures.</span>
      </div>
    </section>
    <section className="section-1">
      <div className="card">
        <h2>MARINE MOGULS <strong>NFTs</strong></h2>
        <h3>Collectibles, Liquidity and Trading profits</h3>
        <div className="row">
          <div className="col text-r card-1">
            Dive into the Marine Moguls NFT Collection, where cutting-edge ERC-404 tech meets MetBot's trading wizardry. Experience the fusion of NFT uniqueness and instant liquidity, crafted into AI art that mocks finance and delivers real AI-driven trading gains to benefit you. Join us for an adventure in blockchain innovation and financial conquest beyond traditional finance's reach.
          </div>
          <div className="col">
            <div className="styled-img-wrap">

            <StaticImage
              src="../images/marine-mogul-1.png"
              loading="lazy"
              width={160}
              quality={95}
              formats={["auto", "webp", "avif"]}
              alt="Marine Mogul Shark"
              className="styled-img"
              />
              </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section-2 col">
      <h2>UNLOCK THE DEPTHS</h2>
      <h3>Marine Moguls NFT Benefits</h3>
      <div className="row">
        <div className="card">
          <FontAwesomeIcon className="icon" icon={faFingerprint} size="2xl" />
          <strong>10,000</strong><br/>unique Marine Moguls NFTs
        </div>
        <div className="card">
          <FontAwesomeIcon className="icon" icon={faGift} size="2xl" />
          <strong>2,500 NFTs</strong><br/>holding additional prizes worth over<br/>
          <strong>2.9 million USDT</strong>
        </div>
        <div className="card">
          <FontAwesomeIcon className="icon" icon={faScissors} size="2xl" />
          <strong>Fractional ownership</strong><br/>of NFTs and instant liquidity - a hallmark of ERC-404 innovation
        </div>
        <div className="card">
          <FontAwesomeIcon className="icon" icon={faStar} size="2xl" />
          <strong>Exclusive access</strong><br/>to MetBot’s High Frequency trading
        </div>
        <div className="card">
          <FontAwesomeIcon className="icon" icon={faHammer} size="2xl" />
          <strong>Crafting and Merging</strong><br/> for higher value NFTs
        </div>
      </div>
    </section>
    <section className="section-2 col">
      <h2>DIVE EARLY INTO MARINE MOGULS</h2>
      <h3>The Prelaunch Expedition</h3>
      <blockquote>Marine Moguls NFTs will launch on May 21<sup>st</sup></blockquote>
      <p>Don't miss the chance to be among the pioneering collectors to navigate these waters.</p>
      <h4>Two Paths to Early Treasures</h4>
      <div className="row">
        <div className="early-1">
          <strong>Airdrop Adventure:</strong>Get free Marine Moguls through our Airdrop Campaign
        </div>
        <div className="early-2">
          <strong>Token Exchange Voyage:</strong>Take partial profits - exchange your staked METFI for Marine Moguls.
        </div>
      </div>
    </section>
    <section className="section-4 col">
      <h2>MEET THE STARS OF THE DEEP BLUE</h2>
      <h3>The Collection</h3>
      <div className="row">
        <div className="col">
          <NftCardBig />
        </div>
        <div className="col start">
        <h4 className="text-l">Meet <strong>Finley Cypher</strong>,</h4>
        <p>
          a humpback whale of considerable renown in the tempestuous seas of digital finance. Not just any marine mammal, Finley sports a monocle emblazoned with a dollar sign, a testament to his sharp eye for lucrative opportunities and perhaps a tad overzealous focus on wealth. Atop his considerable noggin rests a satellite-dish hat, ensuring he's always in the loop with market fluctuations, or maybe just picking up satellite TV for free. His neckwear? A rubber-chicken tie, because nothing says "serious financial advisor" like poultry-themed apparel.
        </p>
        <p>
          Encased in a bulletproof suit of armor (because you never know when a hostile takeover might literally mean underwater warfare), Finley clutches an hourglass, a somber reminder of time’s relentless march, or perhaps just his inability to let go of antiquated decor. Amidst the wreckage of a sunken bank vault, overflowing with gold bars and the elusive digital gold of bitcoins, our intrepid whale cavorts. Finley Cypher doesn't just swim in the digital finance ocean; he dives deep, scouting for treasure amidst the ruins of traditional financial systems, always with a wink and a nod to the absurdity of it all.
        </p>
        <div className="row margin-t">
          <a className="button" href="https://airdrop.marinemoguls.com">Get your free Marine Moguls Airdrop</a>
        </div>
        </div>
      </div>
        <NftCard />
    </section>
    
  </Layout>
)

export const Head = () => (
  <>
    <Seo title="Home" />
  </>
)

export default IndexPage
